import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const ResponsibilityHandoverForm_HandOverResponsibilities_Mutation =
  graphql(`
    mutation ResponsibilityHandoverForm_HandOverResponsibilities(
      $personId: Id!
      $organizationId: Id!
      $replacementPersonId: Id!
      $dryRun: Boolean!
    ) {
      handOverResponsibilities(
        personId: $personId
        organizationId: $organizationId
        replacementPersonId: $replacementPersonId
        dryRun: $dryRun
      ) {
        membership
        entries {
          entityType
          entityId
          code
          title
          status
          reason
        }
      }
    }
  `);

export const useHandOverResponsibilitiesMutation = () =>
  useGraphQLMutation(
    ResponsibilityHandoverForm_HandOverResponsibilities_Mutation,
  );
